<div class="chip" [style.background-color]="statusColor" data-tour="step11">
  <mat-icon *ngIf="!isError">check</mat-icon>
  <mat-icon *ngIf="isError">error</mat-icon>
  {{this.status}}
</div>
